export default __webpack_public_path__ + "static/media/NOKO_5.9354ceec.gif";